import { useList, useParsed } from "@refinedev/core";
import { CardContent, Typography, Box, alpha, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { analyticsCardData } from "@/utils/data-provider/data";
import palette from "@/palette";
import { Card } from "@/components/card";

const statusColors: Record<string, string> = {
    approved: palette.dark.success.dark,
    pending: palette.dark.warning.main,
    inactive: palette.dark.grey[400],
    banned: palette.dark.error.main,
    active: palette.dark.success.dark,
    out_of_stock: palette.dark.error.main,
    draft: palette.dark.grey[500],
    archived: palette.dark.warning.main,
};

export const StatusAnalytics = ({ resource, title, devideBy12 = 3, icon }: { resource: string, title: string, devideBy12?: number, icon: React.ReactNode }) => {

    let { data, isLoading } = useList({ resource });
    let statusCounts = data?.data || [];
    const params = useParsed();
    if (params.pathname == '/dummy-dashboard') {
        isLoading = false;
        // @ts-ignore
        statusCounts = analyticsCardData(resource);
    }

    return (
        <Card
            sx={{
                width: "100%",
                borderRadius: '12px',
                boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                '.MuiCardContent-root': {
                    flexGrow: 1,
                    height: 'auto',
                },
                '&:hover': {
                    boxShadow: '0 6px 25px 0 rgba(0,0,0,0.1)',
                    transform: 'translateY(-2px)'
                }
            }}
            title={title}
            icon={icon}
        >
            <CardContent>
                <Grid container spacing={2} sx={{ paddingBottom: 2 }}>
                    {isLoading ? Array.from({ length: 4 }).map(() => (
                        <Grid size={{
                            xs: 6,
                            sm: 3,
                        }}>
                            <Skeleton variant="rounded" height={75} width={120} />
                        </Grid>
                    )) : (
                        statusCounts.map(({ status, count }) => {
                            return (
                                <Grid size={{
                                    xs: 6,
                                    sm: devideBy12,
                                }} key={status}>
                                    <Box
                                        sx={{
                                            backgroundColor: alpha(statusColors[status] || palette.dark.grey[300], 0.05),
                                            color: statusColors[status] || palette.dark.grey[300],
                                            border: `2px solid ${statusColors[status] || palette.dark.grey[300]}`,
                                            p: 1,
                                            borderRadius: 2,
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="body1" fontWeight="bold" fontSize={12}>{status.replaceAll("_", " ").toUpperCase()}</Typography>
                                        <Typography variant="h6" fontWeight="bold" fontSize={16}>{count}</Typography>
                                    </Box>
                                </Grid>
                            )
                        })
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};